

import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";
import * as _ from "lodash";
import * as angular from "angular";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { EntityService } from "../services/entity-service";
import { EntityConfigService } from "../services/entity-config-service";
import { AdminService } from "../services/admin-service";
import { SearchService } from "../services/search-service";
import { AssetSharedDataService } from "../services/asset-shared-data-service";
import { AclService } from "../services/acl-service";
import { IRLSidepanelPreviewItemComparer, RLAssestAttachmentPreviewItemComparer } from "../directives/sidepanel-preview-item-comparers";
import { AttachmentService } from "../services/attachment-service";
import { BaseAssociationController } from "../controllers/base-associations-controller";
import { AssetService } from "../services/asset-service";
import { BaseEntityController } from "../controllers/baseEntityController";
import { LocalCacheService } from "../services/local-cache-service";
import { BaseEntityAssociationController } from "./rlAdmin.controllers";

export class EntityAttachmentController {
	static $inject = ["$scope", "$sce", "$window", "entityService", "attachmentService", "notifyService", "eventService", "$q", "$timeout", "aclService"];

	entityID: string;
	entityIDObj: Models.IEntityID;
	divID: number;

	pickedFile: IFilestackPickFile;	// file	picked by filepicker.io
	attachments: Models.IAssetAttachment[];             // list of attached files
	attachmentDescription: string;
	entityRecord: Models.IEntity;
	charTypeName: string;
	listUrl: string;
	attachmentTypeID: number;
	attachmentTypes: { [id: string]: number };

	previewFiles: Models.IAssetAttachment[] = [];
	previewFile: Models.IAssetAttachment;

	singleOnlyAttachmentIDs: number[];
	confirmReplaceAttachmentOpen: boolean;
	pickAndStore: boolean;
	makeKeyArt: boolean;
	makeThumb: boolean;
	canCopy: boolean;
	locked: boolean;
	initialized: boolean;

	public previewItemComparer: IRLSidepanelPreviewItemComparer = new RLAssestAttachmentPreviewItemComparer();

	constructor(private $scope: ng.IScope, private $sce: ng.ISCEService, private $window: ng.IWindowService, private entityService: EntityService,
		private attachmentService: AttachmentService, private notifyService: NotifyService, private eventService: EventService,
		private $q: ng.IQService, private $timeout: ng.ITimeoutService, private aclService: AclService) {
		this.pickedFile = null;
		this.attachments = [];
		this.attachmentDescription = null;
		//this.previewFile = <Models.IAssetAttachment>{};
		this.entityRecord = <Models.IEntity>{};
		this.charTypeName = "";
		this.listUrl = "~/";
		this.attachmentTypes = <{ [id: string]: number }>Consts.AttachmentTypeDicts.IDs;
		this.attachmentTypeID = this.attachmentTypes[Consts.AttachmentTypeNames.Other]; //this.attachmentTypes[Consts.AttachmentTypes.Other];

		this.singleOnlyAttachmentIDs = [Consts.AttachmentTypes.KeyArt, Consts.AttachmentTypes.SmallThumb, Consts.AttachmentTypes.Original];
		this.confirmReplaceAttachmentOpen = false;
		this.pickAndStore = false;
		this.makeKeyArt = false;
		this.makeThumb = false;
		this.entityID = "";
		this.entityIDObj = <Models.IEntityID>{};
		this.canCopy = false;
		this.locked = false;
		this.initialized = false;

		$scope.$watch(() => this.entityID,
			(newValue: string, oldValue: string) => {
				if (newValue != oldValue) {
					this.entityIDObj = Utils.IdBuilder.splitEntityID(newValue);
				}
			}, true);

		$scope.$watch(() => this.pickedFile,
			(newValue, oldValue) => {
				if (newValue != oldValue && newValue != null) {
					this.SaveAttachment(newValue[0]);
				}
			}, true);

		$scope.$watch(() => {
			if (this.entityID == null) {
				return null;
			} else {
				return this.entityID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						this.RefreshParent();
					});
				}
			});
	}

	GetAttachmentType(attachmentTypeID: number) {
		var typeName;
		_.each(this.attachmentTypes, (val, key) => {
			if (val == attachmentTypeID) {
				typeName = key;
			}
		});
		return typeName;
	}

	ReloadAttachments(): ng.IPromise<any> {
		this.attachments = [];
		var promises = [];
		promises.push(this.LoadAttachments(Consts.AttachmentTypes.KeyArt));
		promises.push(this.LoadAttachments(Consts.AttachmentTypes.SmallThumb));
		promises.push(this.LoadAttachments(Consts.AttachmentTypes.Original));
		promises.push(this.LoadAttachments(Consts.AttachmentTypes.Other));

		return this.$q.all(promises);
	}

	// appends to attachments
	LoadAttachments(attachmentTypeID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.attachmentService.getAssetAttachments(this.entityID, attachmentTypeID)
			.then((results) => {
				this.attachments = this.attachments.concat(results);
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	ValidateUpload() {
		var continueWithoutPrompt = true;
		//only allow one key art, one thumbnail, one original
		if (_.any(this.singleOnlyAttachmentIDs, s => s == this.attachmentTypeID)) {
			if (_.any(this.attachments, a => a.attachmentTypeID == this.attachmentTypeID)) {
				continueWithoutPrompt = false;
			}
			//also prompt if they are uploading attachment that can overwrite keyart and/or thumb
			if (this.attachmentTypeID == Consts.AttachmentTypeDicts.IDs[Consts.AttachmentTypeNames.Original]) {
				continueWithoutPrompt = false;
			}
		}

		if (!continueWithoutPrompt) {
			this.$scope.$apply(() => {
				this.confirmReplaceAttachmentOpen = true;
			});
		}
		else {
			this.ConfirmPickAndStore();
		}
	}

	ConfirmPickAndStore() {
		this.confirmReplaceAttachmentOpen = false;
		this.pickAndStore = true;
	}

	SaveAttachment(fpFile: IFilestackPickFile) {
		var request: Models.IEntityAttachmentRequest = {
			charTypeID: this.entityIDObj.charTypeID,
			recID: this.entityIDObj.recID,
			path: fpFile.key,
			name: fpFile.filename,
			description: this.attachmentDescription,
			attachmentTypeID: this.attachmentTypeID,
			makeKeyArt: this.makeKeyArt,
			makeThumb: this.makeThumb
		};

		this.notifyService.startProgress();
		var promises = [];
		// call	service
		if (_.any(this.singleOnlyAttachmentIDs, s => s == this.attachmentTypeID) && _.any(this.attachments, a => { return a.attachmentTypeID == this.attachmentTypeID })) {
			var attachment = _.find(this.attachments, a => { return a.attachmentTypeID == this.attachmentTypeID });
			promises.push(this.attachmentService.deleteAssetAttachment(this.entityIDObj.charTypeID, this.entityIDObj.recID, attachment.attachmentID, attachment.attachmentTypeID));
		}
		this.$q.all(promises)
			.then(() => {
				this.attachmentService.saveAttachment(request)
					.then((results) => {
						this.attachmentDescription = null;
						this.ReloadAttachments()
							.then(() => {
								this.notifyService.notifySuccess("Attachment Uploaded");
							});
					})
					.finally(() => {
						this.notifyService.endProgress();
					});
			});

	}

	private RemoveFromPreviewFiles(file: Models.IAssetAttachment) {
		var previewFileIndex: number = _.findIndex(this.previewFiles, previewFile => this.previewItemComparer.IsSameItem(file, previewFile));
		if (previewFileIndex >= 0) {
			this.previewFiles.splice(previewFileIndex, 1);
		}
	}

	// delete associated media
	DeleteAttachment(file: Models.IAssetAttachment) {
		if (this.$window.confirm("Are you sure you want to delete this attachment?")) {
			this.notifyService.startProgress();
			var savedThis: EntityAttachmentController = this;
			// call	service
			this.attachmentService.deleteAssetAttachment(this.entityIDObj.charTypeID, this.entityIDObj.recID, file.attachmentID, file.attachmentTypeID)
				.then(() => {
					this.ReloadAttachments();
					savedThis.RemoveFromPreviewFiles(file);
					if (file == this.previewFile) {
						this.previewFile = <Models.IAssetAttachment>{};
					}
					this.notifyService.notifySuccess("Attachment Deleted");
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	PreviewFile(file: Models.IAssetAttachment) {
		this.previewFile = file;
		_.forEach(this.attachments, (el) => {
			el.videoSrc = null;
		});

		if (this.previewFile.previewType == Consts.PreviewTypes.Video) {
			this.previewFile.videoSrc = this.$sce.trustAsResourceUrl(this.previewFile.mediaUrl);
		}
	}

	// initialize controller
	Init(entityID: string, charTypeName: string, listUrl: string) {
		if (!_.isEmpty(entityID)) {
			this.entityID = entityID;
			this.entityIDObj = Utils.IdBuilder.splitEntityID(entityID);
			var filterCharTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;

			this.aclService.loadActivityAcls()
				.then((acls) => {
					switch (filterCharTypeID) {
						case Consts.CharTypeIDs.inventory:
							this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod17);
							break;
						case Consts.CharTypeIDs.property:
							this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod1);
							break;
					}
				});

			this.entityService.getEntity(entityID).then((result) => {
				this.entityRecord = result.record;
				this.initialized = true;
				if (result.charDataCollection != null) {
					if (result.charDataCollection.status.lockIndicator == 0) {
						this.locked = false;
					}
					else {
						this.locked = true;
					}
				}
				this.ReloadAttachments();
			});
		}
		if (!_.isEmpty(charTypeName)) {
			this.charTypeName = charTypeName;
		}
		if (!_.isEmpty(listUrl)) {
			this.listUrl = listUrl;
		}

	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this " + this.charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + this.charTypeName + "?")) {
			this.notifyService.startProgress();
			this.entityService.deleteEntity(this.entityRecord.id)
				.then(() => {
					this.$window.location.assign(this.listUrl);
				},
				() => {
					this.notifyService.notifyError("Error Deleting " + this.charTypeName + "");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	RefreshAll(): ng.IPromise<any> {
		return this.RefreshValidation();
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	private UpdatePreviewItem(image: Models.IAssetAttachment) {

		var toPreview: Models.IAssetAttachment = _.find(this.attachments, a => this.previewItemComparer.IsSameItem(a, image));
		var existingPreviewItemIndex: number = _.findIndex(this.previewFiles, f => this.previewItemComparer.IsSameItem(f, image));

		if (existingPreviewItemIndex >= 0) {
			this.previewFiles[existingPreviewItemIndex] = toPreview;
		}

		return;
	}

	public RotateImage(image?: Models.IAssetAttachment): ng.IPromise<any> {
		var attachmentToRotate: Models.IAssetAttachment = (image != null) ? image : this.previewFile;
		this.notifyService.startProgress();
		return this.attachmentService.rotateImage(this.entityRecord.charTypeID, this.entityRecord.recordID, attachmentToRotate.attachmentID, attachmentToRotate.attachmentTypeID, 1)
			.then(() => {
				this.ReloadAttachments()
					.then(() => {
						this.UpdatePreviewItem(attachmentToRotate);
						this.notifyService.notifySuccess("Image rotated");
					}).finally(() => {
						this.notifyService.endProgress();
					});
			});
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	RefreshParent() {
		this.entityService.getEntity(this.entityID)
			.then((result) => {
				if (result.charDataCollection.status.lockIndicator == 0) {
					this.locked = false;
				}
				else {
					this.locked = true;
				}
			});
	}
}

export class AssetAssociationsController extends BaseAssociationController<Models.IAssetSearchDoc> {
	static $inject = ["$scope", "$window", "$filter", "$q", "notifyService", "assetService", "entityService", "eventService", "searchService"];

	showInventory: boolean;
	templateGroupIDs: string;

	constructor(
		private $scope: ng.IScope,
		private $window: ng.IWindowService,
		private $filter: ng.IFilterService,
		private $q: ng.IQService,
		private notifyService: NotifyService,
		private assetService: AssetService,
		private entityService: EntityService,
		private eventService: EventService,
		private searchService: SearchService) {

		super($scope, $window, $filter, $q, notifyService, entityService, eventService);

		this.showInventory = true;
		this.templateGroupIDs = "";

		$scope.$watch(() => this.showInventory, (newValue: boolean, oldValue: boolean) => {
			if (newValue != oldValue) {
				if (newValue) {
					this.templateGroupIDs = "1,2";
				} else {
					this.templateGroupIDs = "1";
				}

				this.SubGetAssociationHeirarchy()
					.then((result) => {
						this.nodes = [<Models.IEntityNodeWRelID>result];
					});
			}
		}, true);
	}

	SubGetAssociationHeirarchy() {
		return this.assetService.getHierarchy(this.recordID, this.showInventory);
	}

	SubRemoveAssociated() {
		return this.assetService.deleteAssociations(this.recordID, this.selectedAssociatedIDs);
	}

	SubSetAssociated() {
		return this.assetService.createAssociations(this.recordID, this.selectedSearchIDs);
	}

	SubSearch(searchState: Models.IAdvancedSearchModel) {
		return this.searchService.advancedSearch(searchState);
	}

	SubGetRecordID(itemRow: Models.IAssetSearchDoc) {
		return itemRow.assetID;
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Catalog Item?") && this.$window.confirm("Are you REALLY SURE you want to delete this Catalog Item?")) {
			this.notifyService.startProgress();
			this.entityService.deleteEntity(this.entityRecord.id)
				.then(() => {
					this.$window.location.assign(Consts.Urls.PropertyListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Catalog Item");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	RefreshAll(): ng.IPromise<any> {
		return this.RefreshValidation();
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	CopySuccessful(newEntityID: string) {
		this.$window.location.assign("/Go/" + newEntityID);
	}
}

export class AssetFilesController extends BaseEntityController {
	static $inject = ["$scope", "$sce", "$q", "$window", "localCacheService", "notifyService", "assetSharedDataService", "eventService", "entityService", "aclService"];

	assetID: string;
	initialized: boolean;
	docsInitialized: boolean;
	locked: boolean;
	editDocumentID: string;
	canCopy: boolean;

	constructor(
		$scope: ng.IScope,
		private $sce: ng.ISCEService,
		$q: ng.IQService,
		private $window: ng.IWindowService,
		localStorage: LocalCacheService,
		notifyService: NotifyService,
		private sharedData: AssetSharedDataService,
		private eventService: EventService,
		entityService: EntityService,
		private aclService: AclService) {

		super($scope, $q, entityService, localStorage, notifyService);

		this.assetID = "";
		this.visibility = 1;
		this.initialized = false;
		this.docsInitialized = true;
		this.editDocumentID = null;
		this.locked = false;
		this.canCopy = false;

		$scope.$watch(
			() => this.sharedData.asset != null ? this.sharedData.asset.charDataCollection.status.lockIndicator : 1,
			(newValue, oldValue) => {
				this.locked = newValue > 0;
			});

		$scope.$watch(() => {
			if (this.assetID == null) {
				return null;
			} else {
				return this.assetID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						this.RefreshParent();
					});
				}
			});
	}

	Init(assetID: string) {
		this.assetID = assetID;

		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod1);
			});

		this.notifyService.startProgress();
		this.entityService.getEntity(this.assetID).then((result) => {
			this.entity = result.record;
			if (result.charDataCollection.status.lockIndicator > 0) {
				this.locked = true;
			}
			else {
				this.locked = false;
			}

			this.sharedData.RefreshFiles(this.assetID)
				.then(() => {
					this.initialized = true;
				});
		})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Delete() {
		var listUrl: string = "";
		var charTypeName: string = "";
		switch (Utils.IdBuilder.splitEntityID(this.assetID).charTypeID) {
			case Consts.CharTypeIDs.property:
				listUrl = Consts.Urls.PropertyListPage;
				charTypeName = "Catalog Item";
				break;
			case Consts.CharTypeIDs.inventory:
				listUrl = Consts.Urls.InventoryListPage;
				charTypeName = "Inventory";
				break;
		}

		if (this.$window.confirm("Are you sure you want to delete this " + charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + charTypeName + "?")) {
			this.notifyService.startProgress();


			this.entityService.deleteEntity(this.assetID)
				.then(() => {
					this.$window.location.assign(listUrl);
				},
				() => {
					this.notifyService.notifyError("Error Deleting " + charTypeName);
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	RefreshAll(): ng.IPromise<any> {
		return this.RefreshValidation()
			.then(() => {
				this.docsInitialized = false;
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	RefreshParent() {
		this.entityService.getEntity(this.assetID)
			.then((result) => {
				if (result.charDataCollection.status.lockIndicator > 0) {
					this.locked = true;
				}
				else {
					this.locked = false;
				}
			});
	}
}

export class AssetEntityAssociationSearchController extends BaseEntityAssociationController {
	static $inject = ["$scope", "$location", "$filter", "notifyService", "$window", "$q",
		"eventService", "entityService", "entityConfigService", "adminService", "$interval", "searchService", "assetSharedDataService", "aclService"];

	//Search objects
	keywords: string;
	pages: { [key: number]: number };
	templates: { [key: string]: Models.IKeyValuePair<string, number>[] };
	sortDirs: { [key: number]: string };
	sortFields: { [key: number]: string };
	selectedCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
	selectedTemplate: string;
	selectedStatus: string;
	searchStates: { [key: string]: Models.IAdvancedSearchModel };
	templateFacets: Models.IKeyValuePair<string, string>[];
	statusFacets: Models.IKeyValuePair<string, string>[];

	//Associations objects
	sharedData: AssetSharedDataService;
	filterByEntityID: string;
	charTypesAndTemplateGroups: Models.IAssociationCharTypeAndTemplateGroupExtended[];
	selectedRecords: any[];
	associateCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
	locked: boolean;
	currentCharTypeAndTemplateGroup: Models.IAssociationCharTypeAndTemplateGroupExtended;
	canCreate: boolean = false;
	canEdit: boolean = false;
	currentCharTypeName: string;
	refreshAssociationPanels: boolean;
	canCopy: boolean;
	initialized: boolean;

	constructor(private $scope: ng.IScope, private $location: ng.ILocationService, private $filter: ng.IFilterService,
		public notifyService: NotifyService, private $window: ng.IWindowService,
		public $q: ng.IQService,
		private eventService: EventService,
		private entityService: EntityService,
		private entityConfigService: EntityConfigService,
		public adminService: AdminService,
		public $interval: ng.IIntervalService,
		private searchService: SearchService,
		private assetSharedDataService: AssetSharedDataService,
		private aclService: AclService) {

		super($scope, notifyService, adminService, $interval, $q, entityService, eventService);

		//Search objects
		this.keywords = "";
		this.pages = {};
		this.templates = {};
		this.sortDirs = {};
		this.sortFields = {};
		this.selectedCharType = null;
		this.selectedTemplate = null;
		this.searchStates = {};
		this.templateFacets = [];
		this.statusFacets = [];

		//Associations objects
		this.sharedData = assetSharedDataService;
		this.filterByEntityID = "";
		this.charTypesAndTemplateGroups = [];
		this.selectedRecords = [];
		this.locked = false;
		this.currentCharTypeAndTemplateGroup = { name: "", createName: "", charTypeID: 0, tgIDs: [], isParentChar: false };
		this.currentCharTypeName = "";
		this.refreshAssociationPanels = false;
		this.canCopy = false;
		this.initialized = false;		

		$scope.$watch(() => this.sharedData.assetStatus != null ? this.sharedData.assetStatus.lockIndicator : 1,
			(newvalue, oldvalue) => {
				this.locked = newvalue > 0;
			});
	}

	CharTypeChanged() {
		this.selectedTemplate = null;
		this.selectedStatus = null;
		this.BuildSearchStates();
	}

	TemplateChanged() {
		this.selectedStatus = null;
		this.BuildSearchStates();
	}

	StatusChanged() {
		this.BuildSearchStates();
	}

	Init(filterByEntityID: string, charTypeName: string, charTypeID: string, templateID: string) {
		this.filterByEntityID = filterByEntityID;
		this.baseEntityID = filterByEntityID;
		this.currentCharTypeName = charTypeName;

		//Get ACLs for user
		this.entityService.getEntityRecord(filterByEntityID)
			.then((result) => {
				var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
				this.canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, targetACL);
				this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
			});

		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod1);
			});
		this.LoadTemplateGroups();
		this.sharedData.RefreshAsset(filterByEntityID);
		this.sharedData.RefreshAssetStatus(filterByEntityID)
			.then(() => {
				this.initialized = true;
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		this.refreshAssociationPanels = true;
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	LoadTemplateGroups() {
		this.notifyService.startProgress();

		//Hardcoded list of valid char types per Joe N.
		//16, 1, 17, 4, 15, and 7
		var validCharTypes = [16, 1, 4, 17, 15, 7];

		this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.property)
			.then((results) => {

				_.forEach(results, (result) => {
					var charName = result.charTypeName;

					if (charName == "Transaction") {
						charName = "Deals";
					}
					else if (charName == "Work Orders") {
						charName = "Jobs";
					}
					else if (charName == "Property") {
						charName = "Catalog Items";
					}
					else if (charName == "Invoice") {
						charName = "Accounting";
					}

					if (validCharTypes.indexOf(result.charTypeID) > -1) {
						this.charTypesAndTemplateGroups.push({
							name: charName,
							createName: charName,
							charTypeID: result.charTypeID,
							tgIDs: [1],
							isParentChar: false
						});

						if (this.currentCharTypeName == charName) {
							this.currentCharTypeAndTemplateGroup = {
								name: charName,
								createName: charName,
								charTypeID: result.charTypeID,
								tgIDs: [],
								isParentChar: false
							}
						}
					}
				});
			})
			.finally(() => {
				this.entityConfigService.getRelatedConfigurationParentCharacteristicTypes(Consts.CharTypeIDs.property)
					.then((results) => {
						_.forEach(results, (result) => {
							var charName = result.charTypeName;

							if (charName == "Transaction") {
								charName = "Deals";
							}
							else if (charName == "Work Orders") {
								charName = "Jobs";
							}
							else if (charName == "Property") {
								charName = "Catalog Items";
							}
							else if (charName == "Invoice") {
								charName = "Accounting";
							}

							var charType = { name: charName, createName: charName, charTypeID: result.charTypeID, tgIDs: [1], isParentChar: true }

							//Check to see if the array already has reference to this charType.  If so, we just want to flip the isParentChar flag to true
							//If not, add the new charType

							var matchingCharTypes = this.charTypesAndTemplateGroups.filter(ct => ct.charTypeID == result.charTypeID);

							if (validCharTypes.indexOf(result.charTypeID) > -1) {
								if (matchingCharTypes.length > 0) {
									var index = this.charTypesAndTemplateGroups.indexOf(matchingCharTypes[0]);
									this.charTypesAndTemplateGroups[index].isParentChar = true;
								}
								else {
									this.charTypesAndTemplateGroups.push(charType);
								}

								if (this.currentCharTypeName == charName) {
									this.currentCharTypeAndTemplateGroup = {
										name: charName,
										createName: charName,
										charTypeID: result.charTypeID,
										tgIDs: [],
										isParentChar: true
									}
								}
							}
						});
					})
					.finally(() => {
						//Sort the list based on how Joe wants it
						//Projects, Catalog Items, Deals, Inventory, Jobs, Accounting
						var sortList = [16, 1, 4, 17, 15, 7];

						var sorted = _.sortBy(this.charTypesAndTemplateGroups, function (obj) {
							return _.indexOf(sortList, obj.charTypeID);
						});

						var currentCharTypeIndex = _.findIndex(sorted, c => c.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID);

						this.SortByIndex(sorted, currentCharTypeIndex, 0);

						this.charTypesAndTemplateGroups = sorted;

						this.BuildSearchStates();
						this.notifyService.endProgress();
					});
			});
	}

	SortByIndex(collection: any[], fromIndex: number, toIndex: number) {
		collection.splice(toIndex, 0, collection.splice(fromIndex, 1)[0]);
	}

	SearchSubmit() {
		this.BuildSearchStates();
	}

	BuildSearchStates() {

		var tempSearchStates: { [key: string]: Models.IAdvancedSearchModel } = {};
		this.searchStates = {};

		var selectedCharTypeID = null;

		if (this.selectedCharType != null) {
			selectedCharTypeID = this.selectedCharType.charTypeID;
		}

		//associations
		var metaDataSearchRequest: Models.IAdvancedSearchModel = {
			charTypeID: selectedCharTypeID,
			searchGroups: [],
			keywords: this.keywords,
			page: this.pages[selectedCharTypeID] || 1,
			rowCount: 10,
			templateGroupIDs: [1, 2],
			template: this.selectedTemplate,
			status: this.selectedStatus,
			sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
			sortField: this.sortFields[selectedCharTypeID] || "",
			relatedEntityID: this.filterByEntityID
		};

		this.searchService.advancedSearch(metaDataSearchRequest)
			.then((res) => {
				this.templateFacets = res.getTemplateFacets();
				this.statusFacets = res.getStatusFacets();
			});
		// end reflective association search

		if (this.selectedCharType != null) {
			var searchState: Models.IAdvancedSearchModel = {
				charTypeID: selectedCharTypeID,
				searchGroups: [],
				keywords: this.keywords,
				page: this.pages[selectedCharTypeID] || 1,
				rowCount: 10,
				templateGroupIDs: [1, 2],
				template: this.selectedTemplate,
				status: this.selectedStatus,
				sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
				sortField: this.sortFields[selectedCharTypeID] || "",
				relatedEntityID: this.filterByEntityID,
				explicitRelationshipsOnly: true
			};

			tempSearchStates[this.selectedCharType.name] = searchState;
		}
		else {
			_.each(this.charTypesAndTemplateGroups, ct => {
				var searchState: Models.IAdvancedSearchModel = {
					charTypeID: ct.charTypeID,
					searchGroups: [],
					keywords: this.keywords,
					page: this.pages[selectedCharTypeID] || 1,
					rowCount: 10,
					templateGroupIDs: [1, 2],
					template: this.selectedTemplate,
					status: this.selectedStatus,
					sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
					sortField: this.sortFields[selectedCharTypeID] || "",
					relatedEntityID: this.filterByEntityID,
					explicitRelationshipsOnly: true
				};

				tempSearchStates[ct.name] = searchState;
			});
		}

		var keys = _.keys(tempSearchStates);
		keys.forEach(k => {
			var searchState = tempSearchStates[k];
			if (searchState.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID) {
				searchState.filterByEntityID = this.filterByEntityID;
				searchState.keywords = this.filterByEntityID;
				searchState.relatedEntityID = "";
			}
		});

		this.searchStates = tempSearchStates;
	}

	ClearSearch($event?: ng.IAngularEvent) {
		if ($event != null) {
			$event.preventDefault();
		}
		this.keywords = "";
		this.BuildSearchStates();
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Catalog Item?") && this.$window.confirm("Are you REALLY SURE you want to delete this Catalog Item?")) {
			this.notifyService.startProgress();
			this.entityService.deleteEntity(this.filterByEntityID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.PropertyListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Project");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	ViewEntity(viewEntityID: string) {
		this.entityService.getEntity(viewEntityID)
			.then((res) => {
				this.selectedEntity = res;
			});
	}
}
